export const DECISION_COLUMNS = [
  "Flag",
  "Account Name",
  "Account Owner",
  "Role",
  "Review Decision"
]

export const DECISION_COLUMNS_WIDTHS = [
  150, 250, 250, 200, 600
]

export const HEADER_MAP = {
  "Flag": "flag",
  "Account Name": "account_name",
  "Account Owner": "account_owner",
  "Role": "role",
  "Review Decision": "decision"
}